import React from "react";
import Navbar from "../Components/Navbar";
import Hero from "../Components/Hero";
import Testimonial from "../Components/Testimonial";
import Footer from "../Components/Footer";
import Choiceservics from "./Choiceservics";
import { CartProvider } from "react-use-cart";
import { useContext } from "react";
import { useCart } from "react-use-cart";
import { apivalue } from "../Alldata/Data";
import { NavLink } from "react-router";

function Page() {
  const { addItem, totalItems } = useCart();
  const data = useContext(apivalue);

  return (
    <>
    <div className="product-section" id="pro">
            <div className="container">
              <div className="row">
                {/* Start Column 1 */}
                <div className="col-md-12 col-lg-3 mb-5 mb-lg-0">
                  <h2 className="mb-4 section-title">
                    Crafted with excellent material.
                  </h2>
                  <p className="mb-4">
                    Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet
                    velit. Aliquam vulputate velit imperdiet dolor tempor tristique.{" "}
                  </p>
                  <p>
                    <NavLink to="/shop" className="btn">
                      Explore
                    </NavLink>
                  </p>
                </div>
                {/* End Column 1 */}
      {data.map((el) =>
        el.id > 20 ? (
          <div
            className="col-12 col-md-4 col-lg-3 mb-5"
            key={el.id}
            data-aos="fade-up"
          >
            <a className="product-item">
              <img
                src={el.images[0]}
                alt="img"
                className="img-fluid product-thumbnail"
              />
              <h3 className="product-title">{el.title}</h3>
              <strong className="product-price">${el.price}</strong>

              <span className="icon-cross" onClick={() => addItem(el)}>
                <img src="images/cross.svg" alt="img" className="img-fluid" />
              </span>
            </a>
          </div>
        ) : null
      )}
      </div>
        </div>
      </div>
    </>
  );
}

function Services() {
  return (
    <CartProvider>
      <Navbar />
      <Hero value={<h1>Services</h1>} />
      <Choiceservics />
      <Page/>
      <Testimonial />
      <br></br>
      <br></br>
      <br></br>
 <br></br>
      <br></br>
      <br></br>
      <br></br>
 <br></br>
      <Footer />
    </CartProvider>
  );
}

export default Services;
